<script>
	import gaussian from 'gaussian';
	import OverUnderChart from './OverUnderChart.svelte';
	import PremiumOnly from "./PremiumOnly.svelte";
	export let stats = [];
	export let gamelog = [];
	//not needed iterate over stats instead
	export let props = ["points", "rebounds", "assists", "fantasy points", "points+rebounds+assists", "steals+blocks"];
	export let league = "nba";
	export let premium_membership = true;
	// {stat: {lines: [...], p_over: [...], mean, sd}} from the fair-odds API
	export let fair_odds = null;
	// {stat: [{book, line, over, under, p_over, over_link, under_link}]} sportsbook lines for this game
	export let market_lines = null;
	$: market = marketRows(selected_prop, market_lines, my_dist, value_to_beat);
	// The number in the box means "this many or more", so for 3 assists the
	// bettable line is Over 2.5 (and 3.0 where a book posts whole numbers).
	// When no book posts that, the nearest posted lines are shown instead.
	function marketRows(prop, lines, dist, value) {
		if (!lines || !lines[prop] || !dist) return {rows: [], exact: true, lines: 0};
		let all = lines[prop];
		let at_value = all.filter(r => r.line <= value + 1e-9 && r.line >= value - 0.5 - 1e-9);
		let exact = at_value.length > 0;
		let chosen = at_value;
		if (!exact) {
			let nearest = all.map(r => Math.abs(r.line - value)).sort((a, b) => a - b)[0];
			chosen = all.filter(r => Math.abs(Math.abs(r.line - value) - nearest) < 1e-9);
		}
		let rows = chosen.map(r => {
			let p_over = 1 - dist.cdf(r.line);
			let over_ev = r.over !== null ? p_over * decimalOdds(r.over) - 1 : null;
			let under_ev = r.under !== null ? (1 - p_over) * decimalOdds(r.under) - 1 : null;
			let best = Math.max(over_ev === null ? -Infinity : over_ev, under_ev === null ? -Infinity : under_ev);
			return {
				book: r.book, line: r.line, over: r.over, under: r.under,
				over_link: r.over_link, under_link: r.under_link,
				book_p: r.p_over, model_p: p_over, over_ev, under_ev, best,
				pick: best === over_ev ? "Over" : "Under",
			};
		});
		rows.sort((a, b) => b.best - a.best);
		let best_over = Math.max(...rows.filter(r => r.over !== null).map(r => r.over));
		let best_under = Math.max(...rows.filter(r => r.under !== null).map(r => r.under));
		rows.forEach(r => {
			r.top_over = r.over !== null && r.over === best_over && rows.filter(x => x.over !== null).length > 1;
			r.top_under = r.under !== null && r.under === best_under && rows.filter(x => x.under !== null).length > 1;
		});
		return {rows, exact, lines: all.length};
	}
	function decimalOdds(o) { return o > 0 ? 1 + o / 100 : 1 + 100 / Math.abs(o); }
	function fmtOdds(o) { return (o > 0 ? "+" : "") + o; }
	function fmtEv(ev) { return (ev > 0 ? "+" : "") + (ev * 100).toFixed(1) + "%"; }
	$: setPropMetrics(stats, fair_odds);
	let using_curve = false;
	let selected_prop;
	let value_to_beat;
	let min_value;
	let max_value;
	let my_dist;
	let probability;
	selected_prop = props[0];
	setPropMetrics();
	function probabilityToMoneyLine(probability) {
		if (probability > 0.5) {
			return "-" + Math.round((probability / (1 - probability)) * 100);
		}
		else{
			return "+" + Math.round(((1-probability) / probability) * 100);
		}
		
	}
	function setPropMetrics(){
		//check if props contains selected_prop
		if (!props.includes(selected_prop)) {
			selected_prop = props[0];
		}
		let my_prop = stats.find(obj => {return obj.name === selected_prop});
		my_prop.projection = parseFloat(my_prop.projection);
		let curve = fair_odds ? fair_odds[selected_prop] : null;
		using_curve = !!(curve && curve.lines && curve.lines.length);
		let sd = using_curve ? curve.sd : my_prop.sd;
		value_to_beat = roundHalf(my_prop.projection);
		min_value = roundHalf(my_prop.projection - sd * 2);
		if (min_value < 0) {
			min_value = 0;
		}
		max_value = roundHalf(my_prop.projection + sd * 2);
		// The curve is the empirical distribution of what happened in past games
		// projected like this one (see fantasy/fair_odds.py); cdf(x) = P(under x)
		my_dist = using_curve ? curveDist(curve) : new gaussian(my_prop.projection, my_prop.sd * my_prop.sd);
		probability = my_dist.cdf(value_to_beat);
	}
	function curveDist(curve) {
		let lines = curve.lines;
		let p_over = curve.p_over;
		let step = lines.length > 1 ? lines[1] - lines[0] : 0.5;
		return {
			cdf: function(x) {
				let over;
				if (x < lines[0]) {
					over = 1 - (1 - p_over[0]) * (x / lines[0]);
				} else if (x >= lines[lines.length - 1]) {
					over = p_over[p_over.length - 1];
				} else {
					let i = Math.floor((x - lines[0]) / step);
					let frac = (x - lines[i]) / step;
					over = p_over[i] + (p_over[i + 1] - p_over[i]) * frac;
				}
				return 1 - over;
			}
		};
	}
	function roundHalf(num) {
        return Math.round(num*2)/2;
	}
</script>
<style>
	.market-table td, .market-table th { padding: .3rem .3rem; }
	.book-name { font-size: .85rem; line-height: 1.1; }
	@media (max-width: 575px) {
		.market-table { font-size: .85rem; }
		.market-table td, .market-table th { padding: .25rem .15rem; }
		.odds-btn { padding: .1rem .3rem; font-size: .75rem; }
		.bet-arrow { display: none; }
	}
	.odds-btn {
		font-family: var(--bs-font-monospace);
		font-size: .8rem;
		padding: .1rem .45rem;
		border: 1px solid #cfd4da;
		background: #fff;
		color: #212529;
		white-space: nowrap;
	}
	.odds-btn:hover { border-color: #0d6efd; color: #0d6efd; }
	.odds-btn.best { border-color: #198754; background: #e8f5ee; color: #146c43; font-weight: 600; }
	.odds-btn.disabled { opacity: .75; }
	.bet-arrow { font-size: .65rem; opacity: .6; }
</style>
<div class="p-2">
	<label for="prop-select">Choose a prop</label>
	<select bind:value={selected_prop} on:change={()=>{setPropMetrics()}} class="form-select form-select-lg" id="prop-select">
		{#each props as prop}
		<option value="{prop}">{prop}</option>
		{/each}
	</select>
	
	
	<div class="mt-2 d-flex justify-content-center align-items-center">
		<input style="width:95px;" class="form-control form-control-lg d-inline-block" min="{min_value}" max="{max_value}" step=".5" type=number bind:value={value_to_beat} on:input={()=>{probability = my_dist.cdf(value_to_beat)}}> <h6 class="lead ps-1 my-0">{selected_prop}</h6>
	</div>
	<div class="text-center text-muted small">
		{#if using_curve}
			Based on {fair_odds[selected_prop].n} past games projected like this one
		{:else}
			Based on a normal curve around the projection
		{/if}
	</div>
	{#if premium_membership && market.lines}
	<div class="mx-auto mt-2" style="max-width: 560px;">
		<div class="d-flex justify-content-between align-items-baseline px-1 small text-muted">
			<span>
				{#if market.exact}
					Books posting <strong>{value_to_beat}+ {selected_prop}</strong>, best value first
				{:else}
					No book posts {value_to_beat}+ {selected_prop}; the nearest line is
				{/if}
			</span>
			<span class="d-none d-sm-inline">EV = model vs the book's price</span>
		</div>
		<table class="table table-sm mb-0 align-middle market-table">
			<thead><tr class="text-muted small"><th>Book</th><th class="text-center">Line</th><th class="text-center">Over</th><th class="text-center">Under</th><th class="text-end">Best side</th></tr></thead>
			<tbody>
				{#each market.rows as r}
				<tr>
					<td class="fw-semibold book-name">{r.book}</td>
					<td class="text-center">{r.line}</td>
					<td class="text-center">
						{#if r.over !== null}
							{#if r.over_link}
								<a class="btn btn-sm odds-btn" class:best={r.top_over} href={r.over_link} target="_blank" rel="noopener" title="Bet Over {r.line} at {r.book}">{fmtOdds(r.over)} <span class="bet-arrow">&#8599;</span></a>
							{:else}
								<span class="btn btn-sm odds-btn disabled" class:best={r.top_over}>{fmtOdds(r.over)}</span>
							{/if}
						{:else}<span class="text-muted">&mdash;</span>{/if}
					</td>
					<td class="text-center">
						{#if r.under !== null}
							{#if r.under_link}
								<a class="btn btn-sm odds-btn" class:best={r.top_under} href={r.under_link} target="_blank" rel="noopener" title="Bet Under {r.line} at {r.book}">{fmtOdds(r.under)} <span class="bet-arrow">&#8599;</span></a>
							{:else}
								<span class="btn btn-sm odds-btn disabled" class:best={r.top_under}>{fmtOdds(r.under)}</span>
							{/if}
						{:else}<span class="text-muted">&mdash;</span>{/if}
					</td>
					<td class="text-end small text-nowrap">
						<span class="fw-semibold" class:text-success={r.best > 0} class:text-danger={r.best <= 0}>{r.pick} {fmtEv(r.best)}</span>
						<div class="text-muted" style="font-size: .7rem;">model {(r.model_p * 100).toFixed(0)}%{#if r.book_p !== null} &middot; book {(r.book_p * 100).toFixed(0)}%{/if} over</div>
					</td>
				</tr>
				{/each}
			</tbody>
		</table>
		<div class="text-muted px-1" style="font-size: .7rem;">Tap a price to open that bet at the book. Prices are from the last scan and can move; Polymarket US has no bet links.</div>
	</div>
	{/if}
	<div class="px-5" style="max-height: 275px;">
		<OverUnderChart league={league} selected_prop={selected_prop} line_value={value_to_beat} chart_data={gamelog}/>
	</div>
	<div class="my-1 mx-4">
		<input class="form-range" min="{min_value}" max="{max_value}" step=".5" type=range bind:value={value_to_beat} on:input={()=>{probability = my_dist.cdf(value_to_beat)}}>
	</div>
	<div class="row mt-2">
		{#if !premium_membership}
		<PremiumOnly title_text={"GigaStuds Only!"} text={"Prop Bet Probabilities only available for GigaStuds. <a class='text-decoration-none' href='/purchase-premium'>Become a GigaStud</a> to gain access to all DFStud features!!"} logo_url={window.logo_url}/>
		{:else}
		<div class="text-center col-6">
			<div class="d-flex flex-column">
				<h4>Under</h4>
				<h4 class="lead">Probability: {(probability).toFixed(2)}</h4>
				<h4 class="lead">Moneyline: {probabilityToMoneyLine(probability)}</h4>
			</div>
		</div>
		<div class="text-center col-6">
			<div class="d-flex flex-column">
				<h4>Over</h4>
				<h4 class="lead">Probability: {(1-probability).toFixed(2)}</h4>
				<h4 class="lead">Moneyline: {probabilityToMoneyLine(1-probability)}</h4>
			</div>
		</div>
		{/if}
	</div>
</div>
